__turbopack_context__.v({
  "custom-toggle": "styles-module-scss-module__dlvB6q__custom-toggle",
  "filter-label": "styles-module-scss-module__dlvB6q__filter-label",
  "mobile-help-txt": "styles-module-scss-module__dlvB6q__mobile-help-txt",
  "novelty-badge": "styles-module-scss-module__dlvB6q__novelty-badge",
});
